import axios from 'axios'; // 引入axios实例

const instance = axios.create({
  baseURL: 'http://xianyingmo.cn:8080',
  timeout: 1000 * 5,
});
instance.interceptors.request.use(
  (config) => {
    // 在请求发送之前做些什么
    return config;
  },
  (error) => {
    // 对请求错误做些什么
    return Promise.reject(error);
  }
);

instance.interceptors.response.use(
  (response) => {
    // 对响应数据做点什么
    return response.data;
  },
  (error) => {
    // 对响应错误做点什么
    return Promise.reject(error);
  }
);
export default instance